'use client'

import { ServiceCardRedesigned } from '@/app/(pub)/services/service-card'
import { ServiceItem } from '@/lib/types/operations/service'

interface RelatedServicesProps {
  services: ServiceItem[]
  currentServiceId: string
}

export function RelatedServices({ services, currentServiceId }: RelatedServicesProps) {
  const filteredServices = services.filter(service => service.id !== currentServiceId)

  if (filteredServices.length === 0) {
    return null
  }

  return (
    <section className="space-y-5">
      <h2 className="cw-display-3 text-foreground">You might also like</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredServices.map((service) => (
          <ServiceCardRedesigned
            key={service.id}
            service={service}
            categoryName={service.category?.name}
          />
        ))}
      </div>
    </section>
  )
}
